<template>
  <div id="app">
    <router-view></router-view>
    <loading v-if="isLoading" />
  </div>
</template>

<script>
import appLogin from "assets/commonjs/app";
import user from "assets/commonjs/userInfo";
import { getStore, setStore } from "assets/commonjs/storage";
import loading from "components/loading/loading.vue";
export default {
  name: "App",
  components: { loading },
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {
    this.isLoading = true;
    appLogin
    .getUserInfoFromApp()
      .then((res) => {
        if (res === null || res.account === "") return;
        this.$api.strageList.autoLogin({
          customer: res.account
        }).then((res) => {
          if (res.data == null || res.data == "") {
            //mis后台为调用成功
            toast("app账号和密码不符合要求");
            return;
          }
          const userInfo = res.data.ch_msg[0];
          if (userInfo == null) {
            return;
          }
          const deviceType = {
            "0": "Android",
            "1": "IOS",
            "-1": "PC",
          };
          const deviceInfo = {
            userSource:
              getStore("noneheader") != "" &&
              getStore("noneheader") != undefined &&
              getStore("noneheader") != null
                ? "App"
                : "M站",
            userDevice: deviceType[user.mechined().toString()],
            userDeviceDetail: window.navigator.userAgent,
          };
          const {
            account,
            phone,
            userLevel,
            userName,
            email,
            activeStatus,
          } = userInfo;
          const param = {
            account,
            phone,
            userLevel,
            userName,
            email,
            companyId: 1,
            userType: account.toString().startsWith("11") ? 2 : 1,
            userStatus: activeStatus === "" ? 0 : 1,
            ...deviceInfo,
          };
          this.$api.strageList.loginInfo(param).then((res) => {
            if (res.data && res.data.code == 0) {
              let userToken = res.data.result.userToken;
              setStore("userInfoAll", JSON.stringify(res.data.result));
              this.getData("", userToken);
            } else {
              toast(res.data.message);
            }
          });
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  watch: {
    isLoading: function(newValue) {
      if (newValue) {
        document.body.classList.add("fixed");
      } else {
        document.body.classList.remove("fixed");
      }
    },
  },
};
// if( getStore('lang') == "vn"){
//         document.title = "Chào mừng bạn đến với Trung tâm Cá nhân"
//     }else{
//          document.title = "Welcome to the User Center"
//     }
</script>

<style lang="scss">
@import "./assets/styles/common";
body {
  &.fixed {
    overflow: hidden;
  }
}
</style>
